import { Popover } from '@components/ui/popover'
import type React from 'react'

export default function PopoverRoot({
  children,
}: {
  children: React.ReactNode
}): JSX.Element {
  return <Popover>{children}</Popover>
}
